module.exports = __webpack_public_path__ + "static/img/background.c7a5c9de.jpg";